import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { enableMiddlewareLogPM } from '@api/middlewareSMO';

import { ESnackbarTypes } from '@enums/common';

import { MIDDLEWARE_LOG_PM_ENABLE } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

import useInvalidateMiddlewareSMO from './useInvalidateMiddlewareSMO';

interface IUseMutateMiddlewareEnableLogPMReturned {
	enableMiddlewareLogPM: (id: string) => void;
	isLoadingEnableMiddlewareLogPM: boolean;
}

const useMutateMiddlewareEnableLogPM = (handleCloseModal: () => void): IUseMutateMiddlewareEnableLogPMReturned => {
	const dispatch = useAppDispatch();
	const invalidateMiddlewareSMO = useInvalidateMiddlewareSMO();

	const {
		isLoading,
		mutate,
	} = useMutation<string>({
		mutationKey: [MIDDLEWARE_LOG_PM_ENABLE],
		mutationFn: enableMiddlewareLogPM,
		onSuccess: () => {
			handleCloseModal();

			dispatch(setSnackbar({
				message: responseMessages.enableLogPMFile,
				type: ESnackbarTypes.success,
			}));

			return invalidateMiddlewareSMO();
		},
	});

	return {
		enableMiddlewareLogPM: mutate,
		isLoadingEnableMiddlewareLogPM: isLoading,
	};
};

export default useMutateMiddlewareEnableLogPM;
